import { CustomColumn } from '../../../../types/customColumn';
import { formatCurrency } from '../../../../utils/formatCurrency';
import { PayableTable } from '../../types/Payable.types';

export const PayableTableColumns: CustomColumn<PayableTable>[] = [
  /**
   * 👤 Proveedor
   */
  {
    Header: 'Proveedor',
    accessor: 'supplierName',
    customCell: ({ row }) => (
      <div className="min-w-[240px] max-w-[320px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.supplierName || '—'}
        </div>
      </div>
    ),
  },

  /**
   * 📅 Emisión
   */
  {
    Header: 'Emisión',
    accessor: 'issueDate',
    customCell: ({ value }) => (
      <div className="min-w-[140px]">
        <span className="whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
          {value || '—'}
        </span>
      </div>
    ),
  },

  /**
   * ⏰ Vencimiento
   */
  {
    Header: 'Vencimiento',
    accessor: 'dueDate',
    customCell: ({ row }) => {
      const { dueDate, daysOverdue } = row.original;

      return (
        <div className="min-w-[180px] text-sm">
          <div className="font-medium text-gray-700 dark:text-gray-300">
            {dueDate || '—'}
          </div>

          {daysOverdue > 0 && (
            <div className="mt-1 text-xs font-medium text-red-500">
              {daysOverdue} días vencido
            </div>
          )}
        </div>
      );
    },
  },

  /**
   * 💰 Montos
   */
  {
    Header: 'Montos',
    accessor: 'balance',
    showStatus: true,
    customCell: ({ row }) => {
      const {
        totalAmount,
        paidAmount,
        balance,
      } = row.original;

      return (
        <div className="min-w-[200px] space-y-1 text-sm">
          <div className="font-semibold text-black dark:text-white">
            Total: ${formatCurrency(totalAmount || 0)}
          </div>

          <div className="text-xs text-gray-500 dark:text-gray-400">
            Pagado: ${formatCurrency(paidAmount || 0)}
          </div>

          <div className="text-xs font-semibold text-blue-600 dark:text-blue-400">
            Saldo: ${formatCurrency(balance || 0)}
          </div>
        </div>
      );
    },
  },
];